var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plat-teacher"},[_c('PlatDataGridSite',{attrs:{"grid-id":"PeTeacher","show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }